import { ChangeEvent } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import Input from 'src/view/components/Controls/Input/Input';
import './style.scss';

interface IProps {
  price: string;
  taker360Price: string;
  isTaker360Enabled: boolean | undefined;
  isDisabledPriceChange?: boolean;
  onChange: (value: string) => void;
}

const ItemPrice = ({ price, isTaker360Enabled, isDisabledPriceChange, taker360Price, onChange }: IProps): JSX.Element => {
  const onInputValueChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="d-flex flex-row mt-4">
      <div className="d-flex flex-column">
        <h3 className="item-details-table__heading mb-5">{localeStore.t('price')}</h3>
        <p className="family-medium text-size-16">{price}</p>
      </div>
      {isTaker360Enabled && (
        <div className="d-flex flex-column pl-15">
          <h3 className="item-details-table__heading mb-2">{localeStore.t('taker360_price')}</h3>
          <Input
            className={`menu-group-items-list-row__price input ${isDisabledPriceChange ? 'disabled' : ''}`}
            value={taker360Price ?? ' '}
            disabled={isDisabledPriceChange}
            onChange={onInputValueChange}
          />
        </div>
      )}
    </div>
  );
};

export default ItemPrice;
